/* tr-abnahme-r2.js — Vierzehn Abnahme-Skripte, eine ausführbare Datei.
   Traumreiter CD: R1 (Leerraum, §9 + §10 R1-Bauauftrag) + R2 (Bildsprache, §11).
   Ausführen in der Browser-Konsole der fertigen Seite (Store-Vorschau):

     TR_ABNAHME.vorschalt()   // ZUERST — malt der Tab? Bei null: ABBRECHEN.
     await TR_ABNAHME.alle()  // alle vierzehn, oder einzeln: TR_ABNAHME.r2_2() usw.

   Erwartung erster Lauf (BAUAUFTRAG §5):
     R1 1–4, R1 5–7, R2 1, 3, 4, 7  → grün
     R2 2 (Tonwert)                 → FÄLLT DURCH. Soll er. Liste = Fotobestellung.
     R2 5 (Pfadvertrag), R2 6 (Vergleichspaare) → rot, Liste = Bestellung.
   ⛔ Niemals Korridore weiten, Bilder nachbearbeiten oder Skripte entschärfen,
   damit etwas grün wird. */

window.TR_ABNAHME = (function () {
  'use strict';

  var S = { checkVisibilityCSS: true, checkOpacity: true };

  /* ————— Vorschaltprüfung — der Tab muss malen —————
     Ohne diese Prüfung ist jedes Ergebnis darunter wertlos. */
  function vorschalt() {
    window.TR = { raf: null, timer: null };
    var t0 = performance.now();
    requestAnimationFrame(function () { TR.raf = Math.round(performance.now() - t0); });
    setTimeout(function () { TR.timer = Math.round(performance.now() - t0); }, 50);
    setTimeout(function () {
      console.log('Malt der Tab?', TR, document.visibilityState);
      if (TR.raf === null || document.visibilityState !== 'visible') {
        console.warn('ABBRECHEN. Chrome nach vorne holen, Fenster nicht minimiert, neu starten.');
      }
    }, 900);
  }

  /* ————— Gemeinsamer Einsammler (alle R2-Skripte) —————
     Sichtbar nach checkVisibility, >= 24x24 px, horizontal im Fenster,
     hinunter UND hinauf gesammelt, nach Elementidentität entdoppelt,
     CSS-Hintergrundbilder mitgezählt. */
  window.TRbilder = async function (schritt, warte) {
    schritt = schritt || 600; warte = warte || 420;
    var gefunden = new Map();
    function einsammeln() {
      document.querySelectorAll('*').forEach(function (e) {
        var quelle = null;
        if (e.tagName === 'IMG' && e.currentSrc) quelle = e.currentSrc;
        else {
          var bg = getComputedStyle(e).backgroundImage;
          var m = bg && bg.match(/url\(["']?([^"')]+)/);
          if (m) quelle = m[1];
        }
        if (!quelle) return;
        try { if (!e.checkVisibility(S)) return; } catch (err) { return; }
        var r = e.getBoundingClientRect();
        if (r.width < 24 || r.height < 24) return;
        if (r.right <= 0 || r.left >= innerWidth) return;
        if (!gefunden.has(e)) gefunden.set(e, {
          el: e, quelle: quelle,
          breite: Math.round(r.width), hoehe: Math.round(r.height),
          rolle: e.dataset.trRolle || (e.closest('[data-tr-rolle]') ? e.closest('[data-tr-rolle]').dataset.trRolle : null)
        });
      });
    }
    function halt(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    var hoch = document.documentElement.scrollHeight;
    for (var y = 0; y < hoch; y += schritt) { scrollTo(0, y); await halt(warte); einsammeln(); }
    for (var y2 = hoch; y2 >= 0; y2 -= schritt) { scrollTo(0, y2); await halt(warte); einsammeln(); }
    scrollTo(0, 0);
    return Array.from(gefunden.values());
  };

  /* ═══════════ R1 · Übergabe §9 (4 Skripte) — Erwartung: grün ═══════════ */

  /* R1-1 — Die Sektionsfuge ist überall dieselbe. Erwartung: genau EIN Wert. */
  function r1_1() {
    var werte = Array.prototype.map.call(document.querySelectorAll('.tr-sektion'), function (e) {
      var s = getComputedStyle(e);
      return parseInt(s.paddingTop) + '/' + parseInt(s.paddingBottom)
        + ' m' + parseInt(s.marginTop) + '/' + parseInt(s.marginBottom);
    });
    console.log('Sektionsfugen:', Array.from(new Set(werte))); // erwartet: ['120/0 m0/0']
  }

  /* R1-2 — Kein Abstandswert außerhalb der Skala. Erwartung: 0 */
  function r1_2() {
    var erlaubt = new Set([0, 4, 8, 12, 16, 24, 32, 48, 64, 120]);
    var treffer = {};
    document.querySelectorAll('*').forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.height < 8 || r.width < 60) return;
      try { if (!e.checkVisibility(S)) return; } catch (err) { return; }
      var s = getComputedStyle(e);
      [s.paddingTop, s.paddingBottom, s.marginTop, s.marginBottom, s.rowGap].forEach(function (v) {
        var n = Math.round(parseFloat(v) || 0);
        if (n > 0 && n < 200 && !erlaubt.has(n)) treffer[n] = (treffer[n] || 0) + 1;
      });
    });
    console.log('Verstöße:', Object.keys(treffer).reduce(function (a, k) { return a + treffer[k]; }, 0), treffer);
  }

  /* R1-3 — Textspalten halten ihre Breite. Erwartung: 0 */
  function r1_3() {
    var zuBreit = Array.prototype.filter.call(document.querySelectorAll('.tr-lesetext'), function (e) {
      return e.getBoundingClientRect().width > 481;
    });
    var aussageZuLang = Array.prototype.filter.call(document.querySelectorAll('.tr-aussage'), function (e) {
      return e.textContent.trim().length > 340;
    });
    console.log('Zu breite Lesetexte:', zuBreit.length, '| zu lange Aussagen:', aussageZuLang.length);
  }

  /* R1-4 — Textbudget je Sektion. Erwartung: leer (450) */
  function r1_4() {
    var zuViel = Array.prototype.map.call(document.querySelectorAll('.tr-sektion'), function (e) {
      return e.textContent.trim().replace(/\s+/g, ' ').length;
    }).map(function (n, i) { return { sektion: i, zeichen: n }; })
      .filter(function (x) { return x.zeichen > 450; });
    console.log('Sektionen über Budget:', zuViel);
  }

  /* ═══════════ R1 · Bauauftrag §10 (3 Skripte) — Erwartung: grün ═══════════ */

  /* R1-5 — Keine Fremdanfrage. Erwartung: leeres Array. */
  function r1_5() {
    var fremd = performance.getEntriesByType('resource')
      .map(function (r) { return new URL(r.name).host; })
      .filter(function (h) {
        return !/(^|\.)(myshopify\.com|shopify\.com|cdn\.shopify\.com)$/.test(h) && h !== location.host;
      });
    console.log('Fremdanfragen:', fremd);
  }

  /* R1-6 — Marcellus wird nirgends gefettet. Erwartung: leeres Array. */
  function r1_6() {
    var fett = Array.prototype.filter.call(document.querySelectorAll('*'), function (el) {
      try { if (!el.checkVisibility(S)) return false; } catch (err) { return false; }
      var s = getComputedStyle(el);
      return /Marcellus/.test(s.fontFamily) && Number(s.fontWeight) > 400;
    }).map(function (el) { return el.tagName + ' ' + getComputedStyle(el).fontWeight; });
    console.log('Marcellus gefettet:', fett);
  }

  /* R1-7 — Nichts ist gerundet. Erwartung: leeres Array. */
  function r1_7() {
    var rund = Array.prototype.filter.call(document.querySelectorAll('*'), function (el) {
      try { if (!el.checkVisibility(S)) return false; } catch (err) { return false; }
      var r = getComputedStyle(el).borderRadius;
      return r && r !== '0px' && r !== '0px 0px 0px 0px' && !/50%|9999/.test(r);
    }).map(function (el) { return el.tagName + ' ' + getComputedStyle(el).borderRadius; });
    console.log('Gerundet:', rund);
  }

  /* ═══════════ R2 · Übergabe §11 (7 Skripte) ═══════════ */

  /* R2-1 — Seitenverhältnisse. Erwartung: 0 Verstöße, höchstens 4 Formate. */
  async function r2_1() {
    var erlaubt = { '1:1': 1, '3:2': 1.5, '16:9': 1.7778, '3:1': 3 };
    var bilder = await TRbilder();
    var verstoss = [], gezaehlt = {};
    bilder.forEach(function (b) {
      var v = b.breite / b.hoehe, treffer = null;
      Object.keys(erlaubt).forEach(function (name) {
        if (Math.abs(v - erlaubt[name]) / erlaubt[name] <= 0.02) treffer = name;
      });
      if (treffer) gezaehlt[treffer] = (gezaehlt[treffer] || 0) + 1;
      else verstoss.push({ quelle: b.quelle.slice(-60), ist: v.toFixed(3), px: b.breite + '×', rolle: b.rolle });
    });
    console.log('Bilder gesamt:', bilder.length, '| Formate:', gezaehlt);
    console.log('Verstöße:', verstoss.length, verstoss);
  }

  /* R2-2 — Bildgrund und Tonwert je Rolle. Erwartung erster Lauf: DURCHFALL — Liste = Fotobestellung.
     frei <= 5 Stufen von Weiss · sweep <= 20 von #F1EBE1 · dazu je Rolle der volle Korridor.
     Fassung 2 (UEBERGABE §11, 28.08. abends): alle fünf Werte, welt Bildhelligkeit 125–160.
     Eichprobe vor dem Lauf: #E5E5E5 muss 229 ergeben, #F1EBE1 muss 234 ergeben.
     Weicht die Eichung ab, stimmt die Messkette nicht und kein Ergebnis darunter gilt. */
  async function r2_2() {
    async function tonwerte(el) {
      var q = el.currentSrc || ((getComputedStyle(el).backgroundImage.match(/url\(["']?([^"')]+)/) || [])[1]);
      var bild = new Image(); bild.crossOrigin = 'anonymous'; bild.src = q;
      try { await bild.decode(); } catch (err) { return null; }
      var c = document.createElement('canvas'); c.width = c.height = 48;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(bild, 0, 0, 48, 48);
      var d; try { d = ctx.getImageData(0, 0, 48, 48).data; } catch (err) { return null; }
      var hell = [], ring = [], waerme = [], saett = [];
      for (var y = 0; y < 48; y++) for (var x = 0; x < 48; x++) {
        var i = (y * 48 + x) * 4, r = d[i], gr = d[i + 1], bl = d[i + 2];
        hell.push((r + gr + bl) / 3);
        waerme.push(r - bl);
        saett.push(Math.max(r, gr, bl) - Math.min(r, gr, bl));
        if (x < 3 || y < 3 || x > 44 || y > 44) ring.push((r + gr + bl) / 3);
      }
      function mittel(a) { return a.reduce(function (s, n) { return s + n; }, 0) / a.length; }
      var sortiert = hell.slice().sort(function (a, b) { return a - b; });
      function quantil(p) { return Math.round(sortiert[Math.floor(p * (sortiert.length - 1))]); }
      return {
        bild: Math.round(mittel(hell)),
        grund: Math.round(mittel(ring)),
        waerme: Math.round(mittel(waerme)),
        saett: Math.round(mittel(saett)),
        p10: quantil(0.10),
        p90: quantil(0.90)
      };
    }
    var K = {
      frei:      { grund: 255, tol: 5,  waerme: [0, 8],   saett: 12, hell: [220, 245], p10: 170, p90: null },
      sweep:     { grund: 234, tol: 20, waerme: [0, 10],  saett: 16, hell: [195, 225], p10: 160, p90: 240 },
      vergleich: { grund: 234, tol: 20, waerme: [0, 10],  saett: 16, hell: [195, 225], p10: 160, p90: 240 },
      welt:      { grund: null, tol: 0, waerme: [14, 26], saett: 28, hell: [125, 160], p10: 60,  p90: 210 }
    };
    var bilder = await TRbilder();
    var verstoss = [], ohneRolle = [], nichtMessbar = [];
    for (var k = 0; k < bilder.length; k++) {
      var b = bilder[k];
      if (!b.rolle) { ohneRolle.push(b.quelle.slice(-60)); continue; }
      var korr = K[b.rolle];
      if (!korr) { verstoss.push({ quelle: b.quelle.slice(-60), grund: 'unbekannte Rolle: ' + b.rolle }); continue; }
      var m = await tonwerte(b.el);
      if (!m) { nichtMessbar.push(b.quelle.slice(-60)); continue; }
      var reisst = [];
      if (korr.grund !== null && Math.abs(m.grund - korr.grund) > korr.tol)
        reisst.push('Grund ' + m.grund + ' (soll ' + korr.grund + ' ±' + korr.tol + ')');
      if (m.bild < korr.hell[0] || m.bild > korr.hell[1])
        reisst.push('Helligkeit ' + m.bild + ' (soll ' + korr.hell[0] + '–' + korr.hell[1] + ')');
      if (m.waerme < korr.waerme[0] || m.waerme > korr.waerme[1])
        reisst.push('Wärme ' + m.waerme + ' (soll ' + korr.waerme[0] + '–' + korr.waerme[1] + ')');
      if (m.saett > korr.saett) reisst.push('Sättigung ' + m.saett + ' (soll ≤ ' + korr.saett + ')');
      if (m.p10 < korr.p10) reisst.push('Tiefen p10 ' + m.p10 + ' (soll ≥ ' + korr.p10 + ')');
      if (korr.p90 !== null && m.p90 > korr.p90) reisst.push('Lichter p90 ' + m.p90 + ' (soll ≤ ' + korr.p90 + ')');
      if (reisst.length) {
        verstoss.push({
          rolle: b.rolle, quelle: b.quelle.slice(-60),
          bild: m.bild, grund: m.grund, waerme: m.waerme, saett: m.saett,
          p10: m.p10, p90: m.p90, reisst: reisst
        });
      }
    }
    console.log('Verstöße:', verstoss.length, verstoss);
    console.log('⚠ ohne data-tr-rolle:', ohneRolle.length, ohneRolle);
    console.log('nicht messbar (CORS):', nichtMessbar.length, nichtMessbar);
  }

  /* R2-3 — E1: Preis, Sterne, Badge und Herz liegen NICHT im Bild. Erwartung: 0.
     ⚠ Einziges Skript, das lügen kann: fehlen die Klassen, meldet es 0 Verstöße.
     Klassenzahl wird deshalb mitgemeldet. */
  async function r2_3() {
    var bilder = await TRbilder();
    var rechtecke = bilder.map(function (b) { return { r: b.el.getBoundingClientRect(), q: b.quelle.slice(-50) }; });
    var marken = { '.tr-preis': 'unter', '.tr-sterne': 'unter', '.tr-herz': 'unter',
                   '.tr-badge': 'ueber', '.tr-streichpreis': 'unter', '.tr-siegel': 'verboten' };
    var verstoss = [], klassenzahl = {};
    Object.keys(marken).forEach(function (wahl) {
      var lage = marken[wahl];
      var gefunden = document.querySelectorAll(wahl);
      klassenzahl[wahl] = gefunden.length;
      gefunden.forEach(function (e) {
        try { if (!e.checkVisibility(S)) return; } catch (err) { return; }
        var r = e.getBoundingClientRect();
        rechtecke.forEach(function (b) {
          var ueberlappt = r.left < b.r.right && r.right > b.r.left
                        && r.top < b.r.bottom && r.bottom > b.r.top;
          if (ueberlappt) verstoss.push({ element: wahl, lage: lage, bild: b.q, grund: 'liegt IM Bild' });
        });
        if (lage === 'ueber' || lage === 'unter') {
          var naechstes = rechtecke
            .map(function (b) { return { b: b, abstand: Math.min(Math.abs(r.top - b.r.bottom), Math.abs(b.r.top - r.bottom)) }; })
            .sort(function (a, c) { return a.abstand - c.abstand; })[0];
          if (naechstes && naechstes.abstand < 200) {
            var istUeber = r.bottom <= naechstes.b.r.top + 1;
            if (lage === 'ueber' && !istUeber) verstoss.push({ element: wahl, grund: 'Badge nicht ÜBER dem Bild' });
            if (lage === 'unter' && istUeber) verstoss.push({ element: wahl, grund: 'gehört UNTER das Bild' });
          }
        }
      });
    });
    console.log('Klassenzahl (Gegenprobe):', klassenzahl);
    console.log('Verstöße:', verstoss.length, verstoss);
  }

  /* R2-4 — Bildtakt: rund ein Bild je 1000 px. Erwartung: keine Sektion über 1,3.
     Kachelraster ausgenommen (data-tr-raster), Bestseller-Leiste NICHT. */
  async function r2_4() {
    await TRbilder();
    var zuDicht = [];
    document.querySelectorAll('.tr-sektion').forEach(function (s, i) {
      if (s.matches('[data-tr-raster]')) return;
      var h = s.getBoundingClientRect().height;
      var n = Array.prototype.filter.call(s.querySelectorAll('img, [style*="background-image"]'), function (e) {
        try { return e.checkVisibility(S); } catch (err) { return false; }
      }).filter(function (e) {
        var r = e.getBoundingClientRect(); return r.width >= 24 && r.height >= 24;
      }).length;
      var takt = n / (h / 1000);
      if (takt > 1.3) zuDicht.push({ sektion: i, hoehe: Math.round(h), bilder: n, takt: takt.toFixed(2) });
    });
    console.log('Sektionen über Takt:', zuDicht.length, zuDicht);
  }

  /* R2-5 — Der Pfadvertrag. Erwartung erster Lauf: rot — Liste = Bestellung.
     /produkt/ansicht/variante/name-…-<seitenverhaeltnis>.webp */
  async function r2_5() {
    var ansichten = ['frei','seite','winkel','ecke','detail','sweep','modell','welt','raum-oben','schema','vergleich'];
    var formate = ['1-1','3-2','16-9','3-1'];
    var muster = new RegExp('/([a-z0-9-]+)/(' + ansichten.join('|') + ')/([a-z0-9-]+)/[a-z0-9-]+-(' + formate.join('|') + ')\\.(webp|avif)$');
    var bilder = await TRbilder();
    var verstoss = [], ok = [];
    bilder.forEach(function (b) {
      var pfad = new URL(b.quelle, location.href).pathname;
      var t = pfad.match(muster);
      if (!t) { verstoss.push({ pfad: pfad, rolle: b.rolle }); return; }
      var istFormat = b.breite / b.hoehe;
      var sollFormat = { '1-1': 1, '3-2': 1.5, '16-9': 1.7778, '3-1': 3 }[t[4]];
      if (Math.abs(istFormat - sollFormat) / sollFormat > 0.02)
        verstoss.push({ pfad: pfad, grund: 'Name sagt ' + t[4] + ', gemessen ' + istFormat.toFixed(3) });
      else ok.push({ produkt: t[1], ansicht: t[2], variante: t[3], format: t[4] });
    });
    console.log('Vertragsbruch:', verstoss.length, verstoss);
    console.table(ok);
  }

  /* R2-6 — Vergleichspaare vollständig. Erwartung erster Lauf: rot — Liste = Bestellung.
     Jede Vergleichsansicht existiert für ALLE Varianten ihrer Achse, alle in 16:9. */
  async function r2_6() {
    var achsen = { form: ['u','j'], groesse: ['m','l','xl','xxl'] };
    var bilder = (await TRbilder()).filter(function (b) { return b.rolle === 'vergleich'; });
    var nachProdukt = {};
    bilder.forEach(function (b) {
      var t = new URL(b.quelle, location.href).pathname.match(/\/([a-z0-9-]+)\/vergleich\/([a-z0-9-]+)\//);
      if (!t) return;
      (nachProdukt[t[1]] = nachProdukt[t[1]] || new Set()).add(t[2]);
    });
    var luecken = [], falschesFormat = [];
    bilder.forEach(function (b) {
      if (Math.abs(b.breite / b.hoehe - 1.7778) / 1.7778 > 0.02)
        falschesFormat.push({ quelle: b.quelle.slice(-60), px: b.breite + '×' + b.hoehe });
    });
    Object.keys(nachProdukt).forEach(function (produkt) {
      var hat = nachProdukt[produkt];
      Object.keys(achsen).forEach(function (achse) {
        var soll = achsen[achse];
        var drin = soll.filter(function (v) { return hat.has(v); });
        if (drin.length > 0 && drin.length < soll.length)
          luecken.push({ produkt: produkt, achse: achse, fehlt: soll.filter(function (v) { return !hat.has(v); }) });
      });
    });
    console.log('Unvollständige Paare:', luecken.length, luecken);
    console.log('Vergleichsbilder nicht 16:9:', falschesFormat.length, falschesFormat);
  }

  /* R2-7 — Rechtsgrenze (E6, HWG). Erwartung: 0 Treffer im EIGENEN Text.
     Läuft über die Beratungsstrecke, nicht über die Produktseiten.
     Fremde Stimmen (blockquote, .tr-kundenmeinung) sind ausgenommen (Stufe 3, erlaubt).
     Kann Bilder NICHT beurteilen — Sichtprüfung bleibt. */
  function r2_7() {
    var re = /\b(schmerz|weh|beschwerd|verspann|diagnos|leiden|behandel|linder|heil|therap|symptom|krankheit)\w*\b/giu;
    var treffer = [];
    function istZitat(e) { return e.closest('blockquote, .tr-kundenmeinung, [data-tr-zitat]'); }
    document.querySelectorAll('.tr-frage, .tr-antwort, .tr-beratung, h1,h2,h3,p,li,button').forEach(function (e) {
      if (istZitat(e)) return;
      try { if (!e.checkVisibility(S)) return; } catch (err) { return; }
      var t = e.textContent.trim();
      var m = t.match(re);
      if (m) treffer.push({ wort: Array.from(new Set(m)).join(', '), text: t.slice(0, 90), tag: e.tagName });
    });
    var ohneTranskript = Array.prototype.filter.call(document.querySelectorAll('audio'), function (a) {
      return !a.closest('[data-tr-transkript]') && !(a.parentElement && a.parentElement.querySelector('[data-tr-transkript]'));
    });
    var ohneKennzeichnung = Array.prototype.filter.call(document.querySelectorAll('audio'), function (a) {
      return !a.closest('.tr-kundenmeinung');
    });
    console.log('Rechtstreffer im eigenen Text:', treffer.length, treffer);
    console.log('Tonaufnahmen ohne Transkript:', ohneTranskript.length);
    console.log('Tonaufnahmen ohne Kennzeichnung „Kundenmeinung":', ohneKennzeichnung.length);
  }

  /* ————— Zusatzprüfung (nicht Teil der vierzehn): 05 A Randlos-Deckel —————
     Genau zwei Sections duerfen .tr-randlos tragen: Buehne + Kategorieband. */
  function randlos() {
    var flaechen = Array.prototype.map.call(document.querySelectorAll('.tr-randlos'), function (e) {
      return e.closest('.shopify-section') ? e.closest('.shopify-section').id : e.tagName;
    });
    console.log('Randlos-Flächen (' + flaechen.length + ' von max. 2):', flaechen);
    if (flaechen.length > 2) console.warn('VERSTOSS 05 A: mehr als zwei randlose Flächen.');
  }

  async function alle() {
    console.group('R1 (4)'); r1_1(); r1_2(); r1_3(); r1_4(); console.groupEnd();
    console.group('R1 Bauauftrag (3)'); r1_5(); r1_6(); r1_7(); console.groupEnd();
    console.group('R2 (7) — R2-2/5/6 duerfen rot sein, Listen = Bestellung');
    await r2_1(); await r2_2(); await r2_3(); await r2_4(); await r2_5(); await r2_6(); r2_7();
    console.groupEnd();
    randlos();
  }

  return {
    vorschalt: vorschalt,
    r1_1: r1_1, r1_2: r1_2, r1_3: r1_3, r1_4: r1_4,
    r1_5: r1_5, r1_6: r1_6, r1_7: r1_7,
    r2_1: r2_1, r2_2: r2_2, r2_3: r2_3, r2_4: r2_4, r2_5: r2_5, r2_6: r2_6, r2_7: r2_7,
    randlos: randlos,
    alle: alle
  };
})();
